// extracted by mini-css-extract-plugin
export default {"OrderDetail":"OrderDetail_OrderDetail__oQSZ8","Order":"OrderDetail_Order__wSQnS","imagePart":"OrderDetail_imagePart__ab0zd","detailPart":"OrderDetail_detailPart__93bDd"};